import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import { noop } from 'lodash';

// New modal using new library react-responsive-modal (React 16+ compatibility)
export class ResponsiveEmptyBox extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const styles = {
            modal: {
                width: this.props.popupWidth,
                maxWidth: this.props.popupWidth,
            },
            overlay: {
                zIndex: this.props.zIndex
            }
        };

        return (
            <Modal {...this.props} classNames={{modal:"modal-content", overlay: "modal-overlay"}} open center onClose={this.props.onClose ? this.props.onClose : noop} showCloseIcon={false} styles={styles} container={this.props.container}>
                {
                    this.props.showCloseButton ?  <button className="popup-close-icon" onClick={this.props.onClose}>
                        <svg width="40" height="40">
                            <circle cx="20" cy="20" r="20" fill="black"></circle>
                            <g transform="rotate(45 20 20)">
                                <rect x="8" y="19.25" width="24" height="1.5" fill="white"></rect>
                                <rect y="8" x="19.25" height="24" width="1.5" fill="white"></rect>
                            </g>
                        </svg>
                    </button> : null
                }
                {this.props.children}
            </Modal>
        );
    }
}
ResponsiveEmptyBox.propTypes = {
    onClose: PropTypes.func.isRequired,
    focusTrapped: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    popupWidth: PropTypes.string,
    container: PropTypes.object,
    zIndex: PropTypes.number
};
ResponsiveEmptyBox.defaultProps = {
    focusTrapped: false,
    showCloseButton: true,
    zIndex: 10000
};
